import Comment from '../input/Comment.component';
import {PopUp} from './PopUp.component';
import {DOCUMENT_ACTIONS} from 'utils/constants';
import translate from '../translations/translations.wrapper.jsx';
import * as Api from 'utils/api/api.js';
import {handleError} from 'utils/errorHandle.function';
import {PATH_TO_DOCUMENT_OVERVIEW} from "components/router/paths.js";
import React from "react";
import { Button, ButtonType } from "components/common/Button.component";

//this is to make sure the tabbing stays inside the dialog
const TAB_INDEX = 1000;


export class CancelDocuments extends PopUp {

    constructor(props) {
        super(props);
        this.ok = this.ok.bind(this);
        this.buildContent = this.buildContent.bind(this);
        this.focusFirst = this.focusFirst.bind(this);

        this.state = {
            comment: '',
            actionRunning: false // we're waiting for backend call result
        }

        this.okButton = React.createRef();
        this.commentInput = React.createRef();
    }

    ok() {
        const self = this;

        this.setState({actionRunning: true});

        const taskIds = this.props.tasks.map((task) => {
            return task.key;
        });

        let commentToSend = this.state.comment ? this.state.comment : '';

        Api.cancelDocument(this.props.companyId, taskIds[0], commentToSend).then(response => {
            self.props.showNotification(response.message);
            self.setState({actionRunning: false});
            self.props.handledTaskCallback(undefined, self.props.navigate);
            self.props.closeCallback();
            self.props.navigate(PATH_TO_DOCUMENT_OVERVIEW);
        }, error => {
            handleError(error);
        });

    }

    componentDidMount() {
        super.componentDidMount();
        this.focusFirst();
    }

    focusFirst() {
        this.commentInput.current?.focus();
    }

    buildContent() {

        const okEnabled = !this.state.actionRunning;
        return (
            <div>
                <div className="modal-body">
                    <Comment
                        ref={this.commentInput}
                        inputHint={this.props.translate("popUp.approve.commentHint")}
                        translate={this.props.translate}
                        tabIndex={TAB_INDEX}
                        id="comment"
                        value={this.state.comment}
                        propagateValue={value => this.setState({comment: value})}
                        label={this.props.translate("popUp.approve.commentLabel")}
                    />
                </div>

                <div className="modal-footer">
                    <div className="d-flex gap-8 float-right">
                        <Button type={ButtonType.PRIMARY}
                                onClick={this.ok}
                                disabled={!okEnabled}
                                ref={this.okButton}
                                tabIndex={TAB_INDEX + 1}
                                text={this.props.translate("popUp.ok")}
                        />
                        <Button type={ButtonType.SECONDARY}
                                onBlur={this.focusFirst}
                                onClick={this.props.closeCallback}
                                tabIndex={TAB_INDEX + 2}
                                text={this.props.translate("popUp.cancel")}
                        />
                    </div>
                </div>
            </div>

        );
    }

    getType() {
        return DOCUMENT_ACTIONS.CANCEL_DIRECTLY;
    }

    getTitle() {
        return this.props.translate("popUp.cancelDocuments.title", this.props.tasks[0].description);
    }

}

const withTranslations = translate(CancelDocuments);
export default withTranslations;
